import { jsx as u } from "react/jsx-runtime";
import { forwardRef as c } from "react";
const e = c(function(t, i) {
  return /* @__PURE__ */ u(
    "button",
    {
      ref: i,
      ...t,
      onClick: (n) => {
        var o;
        n.preventDefault = () => {
        }, (o = t.onClick) == null || o.call(t, n);
      }
    }
  );
}), m = c(function(t, i) {
  return /* @__PURE__ */ u(
    "div",
    {
      ref: i,
      ...t,
      onClick: (n) => {
        var o;
        n.preventDefault = () => {
        }, n.stopPropagation = () => {
        }, (o = t.onClick) == null || o.call(t, n);
      }
    }
  );
});
export {
  e as TooltipCustomButton,
  m as TooltipCustomDiv
};
